module.exports = __webpack_public_path__ + "public/images/program/program-3.b46f5f323076427b77fb55ffd48b3b66.png";